import { uniqueId } from 'lodash-es';
import { useRef } from 'react';

export const useNewUniqueId = () => {
  const ref = useRef<number>(Number(uniqueId()));

  return -ref.current;
};
